import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OtEventListComponent } from './ot-event-list/ot-event-list.component';
import { OtRegistrationSuccessComponent } from './ot-registration-success/ot-registration-success.component';
import { OtRegistrationPersonComponent } from './ot-registration-person/ot-registration-person.component';
import { OtRegistrationPriceComponent } from './ot-registration-price/ot-registration-price.component';
import { OtCityListComponent } from './ot-city-list/ot-city-list.component';
import { OtRegistrationSummaryComponent } from './ot-registration-summary/ot-registration-summary.component';

const otRoutes: Routes = [
  {
    path: 'city/list',
    component: OtCityListComponent,
  }, {
    path: 'city/:cityId/ot/event/list',
    component: OtEventListComponent,
  }, {
    path: 'city/:cityId/ot/event/:otEventId/registration/price',
    component: OtRegistrationPriceComponent,
  }, {
    path: 'city/:cityId/ot/event/:otEventId/registration/person',
    component: OtRegistrationPersonComponent,
  }, {
    path: 'city/:cityId/ot/event/:otEventId/registration/summary',
    component: OtRegistrationSummaryComponent,
  }, {
    path: 'city/:cityId/ot/event/:otEventId/registration/:registrationId/:secureHash/success',
    component: OtRegistrationSuccessComponent,
  }, {
    path: '',
    redirectTo: '/city/list',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(otRoutes)],
  exports: [RouterModule]
})
export class OtRoutingModule { }
